export const PERMISSIONS = {
  access_credit_limit_module: "access_credit_limit_module",
  access_it_module: "access_it_module",
  access_lead_module: "access_lead_module",
  access_marketplace_module: "access_marketplace_module",
  access_supplier_factoring_module: "access_supplier_factoring_module",
  access_supplier_reverse_factoring_module:
    "access_supplier_reverse_factoring_module",
  add_contact_group: "add_contact_group",
  add_department_contact: "add_department_contact",
  add_group_permission: "add_group_permission",
  add_groups: "add_groups",
  add_permissions: "add_permissions",
  add_user: "add_user",
  approval_level_ceo: "approval_level_ceo",
  approval_level_head_compliance: "approval_level_head_compliance",
  approval_level_head_funding: "approval_level_head_funding",
  approval_level_head_icpl: "approval_level_head_icpl",
  approval_level_head_legal: "approval_level_head_legal",
  approval_level_head_risk: "approval_level_head_risk",
  approve_credit_limit: "approve_credit_limit",
  create_lead: "create_lead",
  delete_user: "delete_user",
  dashboard_admin: "dashboard_admin",
  get_account: "get_account",
  get_all_accounts: "get_all_accounts",
  get_all_credit_limits: "get_all_credit_limits",
  get_all_departments: "get_all_departments",
  get_all_groups: "get_all_groups",
  get_all_leads: "get_all_leads",
  get_all_permissions: "get_all_permissions",
  get_all_users: "get_all_users",
  get_assigned_credit_limits: "get_assigned_credit_limits:",
  get_credit_limit: "get_credit_limit",
  get_insurer: "get_insurer",
  get_platform_usage: "get_platform_usage",
  manage_org_chart: "manage_org_chart",
  map_admin: "map_admin",
  map_access_compliance: "map_access_compliance",
  map_access_legal: "map_access_legal",
  map_access_risk: "map_access_risk",
  map_view_compliance: "map_view_compliance",
  map_view_legal: "map_view_legal",
  map_view_risk: "map_view_risk",
  reject_credit_limit: "reject_credit_limit",
  request_credit_limit: "request_credit_limit",
  restricted_view_stats: "restricted_view_stats",
  show_accounts: "show_accounts",
  show_balances: "show_balances",
  show_campaign_testing: "show_campaign_testing",
  show_cargo_tracking: "show_cargo_tracking",
  show_cl_report: "show_cl_report",
  show_company_profile: "show_company_profile",
  show_configuration: "show_configuration",
  show_countries: "show_countries",
  show_credit_limits: "show_credit_limits",
  show_dashboard: "show_dashboard",
  show_emails: "show_emails",
  show_ewallet: "show_ewallet",
  show_guides: "show_guides",
  show_insurer_stats: "show_insurer_stats",
  show_invoice_statuses: "show_invoice_statuses",
  show_leads: "show_leads",
  show_leaves: "show_leaves",
  show_maps: "show_maps",
  show_onboarding_statuses: "show_onboarding_statuses",
  show_onboardings: "show_onboardings",
  show_organization_chart: "show_organization_chart",
  show_platform_usage: "show_platform_usage",
  show_request_financing: "show_request_financing",
  show_risk_management: "show_risk_management",
  show_scripts: "show_scripts",
  show_statuses: "show_statuses",
  show_support_tickets: "show_support_tickets",
  show_tax_invoices: "show_tax_invoices",
  show_termsheets: "show_termsheets",
  show_billings: "show_billings",
  show_user_management: "show_user_management",
  test_customer_io: "test_customer_io",
  termsheet_editor: "termsheet_editor",
  termsheet_approver: "termsheet_approver",
  update_contact_account_permissions: "update_contact_account_permissions",
  update_contact_group: "update_contact_group",
  update_credit_limit: "update_credit_limit",
  update_department_contact: "update_department_contact",
  update_group_permission: "update_group_permission",
  termsheet_financing: "termsheet_financing"
};
